// extracted by mini-css-extract-plugin
module.exports = {"item":"userProfileSuperviseeItem_item__263Pl","truncate":"userProfileSuperviseeItem_truncate__12Tik"};